import { render, staticRenderFns } from "./XWindow.vue?vue&type=template&id=417b00b4&scoped=true&"
import script from "./XWindow.vue?vue&type=script&lang=js&"
export * from "./XWindow.vue?vue&type=script&lang=js&"
import style0 from "./XWindow.vue?vue&type=style&index=0&id=417b00b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "417b00b4",
  null
  
)

export default component.exports